// ✅ COMPONENTE: ArticleImagesUploader
// Este componente permite seleccionar un archivo de imagen y subirlo
// a la base de datos asociado a un artículo mediante su ID.
// Utiliza base64 para enviar la imagen como contenido binario.

import React, { useState } from "react";
import { Button } from "@mui/material";
import axios from "axios";

// ✅ Definimos el componente como funcional y tipado con TypeScript.
// Recibe el ID del artículo al que se vinculará la imagen.
const ArticleImagesUploader = ({ articleId, setIsImageUploading, refresh }: { articleId: number, setIsImageUploading: any, refresh: any }) => {
  // Estados internos para archivo seleccionado, estado de carga y mensaje de resultado
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const [uploading, setUploading] = useState(false);
  const [message, setMessage] = useState("");

  // ✅ Manejador cuando el usuario selecciona un archivo
  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      setSelectedFile(file);
      setMessage(""); // Limpia mensaje anterior
    }
  };

  // ✅ Manejador de la subida de imagen al backend
  const handleUpload = () => {
    setIsImageUploading(true);
    // Validamos existencia de archivo e ID de artículo
    if (!selectedFile || !articleId) return;

    const reader = new FileReader();

    // ✅ Al convertir a base64, se envía al backend vía PUT
    reader.onload = async () => {
      const base64 = (reader.result as string).split(",")[1];
      setUploading(true); // Estado de carga visual

      try {
        const res = await axios({
          method: "put",
          url: "http://localhost/catalogmx/index.php/image/features",
          headers: { "Content-Type": "application/json" },
          data: {
            articleId,
            fileName: selectedFile.name,
            fileContent: base64,
          },
        });

        // ✅ Resultado exitoso
        if (res.data?.created === "yes") {
          setMessage("✅ Image uploaded successfully!");
          setSelectedFile(null); // Limpiamos selección
          refresh();
        } else {
          setMessage("❌ Error while saving image");
        }
      } catch (err) {
        console.error(err);
        setMessage("❌ Error: no conetion or invalid format");
      } finally {
        setUploading(false); // Finaliza la carga
      }
    };

    setTimeout(() => {
      setIsImageUploading(false);
    }, 500);
    reader.readAsDataURL(selectedFile); // Convierte imagen a base64
  };

  // ✅ Renderizamos el input y el botón con estado visual y mensaje
  return (
    <div style={{ marginTop: "1rem" }}>
      {/* Input tipo archivo, solo acepta imágenes */}
      <input type="file" accept="image/*" onChange={handleFileChange} />

      {/* Botón para ejecutar la subida */}
      <Button
        variant="contained"
        color="primary"
        onClick={handleUpload}
        disabled={uploading || !selectedFile}
        style={{ marginLeft: "1rem" }}
      >
        {uploading ? "Uploading..." : "Upload Image"}
      </Button>

      {/* Mensaje de estado */}
      {message && <p style={{ marginTop: "0.5rem" }}>{message}</p>}
    </div>
  );
};

export default ArticleImagesUploader;
